__turbopack_context__.v({
  "answerContent": "VoI6za_answerContent",
  "answerText": "VoI6za_answerText",
  "answerWrapper": "VoI6za_answerWrapper",
  "divider": "VoI6za_divider",
  "expanded": "VoI6za_expanded",
  "faqContainer": "VoI6za_faqContainer",
  "faqItem": "VoI6za_faqItem",
  "iconWrapper": "VoI6za_iconWrapper",
  "itemsContainer": "VoI6za_itemsContainer",
  "questionButton": "VoI6za_questionButton",
  "questionLetter": "VoI6za_questionLetter",
  "questionText": "VoI6za_questionText",
  "rotated": "VoI6za_rotated",
  "subtitle": "VoI6za_subtitle",
  "title": "VoI6za_title",
  "titleContainer": "VoI6za_titleContainer",
});
